import { connect } from "react-redux";
import { chargePointActions } from "../../store/actions/chargePoint.actions";
import { bindActionCreators } from "redux";
import InputElementComponent from "../../components/common/InputElementComponent";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { inputElementModel } from "../../models/common/inputElement.model";
import { buttonElementModel } from "../../models/common/buttonElement.model";
import ButtonElementComponent from "../../components/common/ButtonElementComponent";
import validationHelper from "../../utils/helpers/validation.helper";
import alertService from "../../services/alert/alert.service";
import LoaderComponent from "../../components/LoaderComponent";
import driverSecurityErrorEnum from "../../enums/errors/transactions/driverSecurity/driverSecurityError.enum";

export const ChargingTransactionLoginPage = ({ chargePointActions }) => {
  const navigate = useNavigate();
  const { chargePointId } = useParams();

  const [transactionLoginCredentials, setTransactionLoginCredentials] = useState({ identificationValue: "", last4Digit: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setTransactionLoginCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const getOpenChargingTransactionTokenResponse = await chargePointActions.getOpenChargingTransactionToken(
      chargePointId,
      transactionLoginCredentials.identificationValue,
      transactionLoginCredentials.last4Digit
    );
    if (!validationHelper.validateHttpResponse(getOpenChargingTransactionTokenResponse) || !getOpenChargingTransactionTokenResponse.payload) {
      // Spec 000306 - five failures per 15 minutes per charger and number.
      if (getOpenChargingTransactionTokenResponse?.errorCode === driverSecurityErrorEnum.LoginLimit) {
        alertService.error("יותר מדי ניסיונות", "נסו שוב בעוד 15 דקות");
      } else {
        alertService.error("טרנזקציית טעינה לא נמצאה!", "אנא וודא כי אמצעי הזיהוי שהזנת תקינים וטרנזקציית הטעינה פעילה ונסה שנית");
      }
      setIsLoading(false);
      return;
    }
    const getChargePointResponse = await chargePointActions.getChargePointDetails(chargePointId);
    if (!validationHelper.validateHttpResponse(getChargePointResponse)) {
      alertService.error("עמדת טעינה לא נמצא!", "שגיאה בקבלת פרטי עמדת הטעינה. אנא נסה שנית מאוחר יותר");
      return;
    }
    navigate(`/company/${getChargePointResponse.payload.companyId}/chargePoint/${chargePointId}/chargingTransaction/${getOpenChargingTransactionTokenResponse.payload}`);
    setIsLoading(false);
  };

  const getEmailPhoneInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      name: "identificationValue",
      value: transactionLoginCredentials.identificationValue,
      onChange: handleInputChange,
      placeholder: 'דוא"ל/מספר נייד',
      label: "הזן אחד מאמצעי הזיהוי איתו נירשמת",
      required: true,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getLast4DigitInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      name: "last4Digit",
      value: transactionLoginCredentials.last4Digit,
      onChange: handleInputChange,
      placeholder: "4 ספרות אחרונות",
      label: "הזן את 4 הספרות האחרונות של אמצעי התשלום",
      required: true,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getSubmitButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "כניסה לפרטי הטעינה",
      onClick: handleSubmit,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  if (isLoading) return <LoaderComponent />;

  return (
    <div className="flexColumn gap10">
      <h3>שים לב! מטען זה בשימוש. דרך מסך זה, תוכל להיכנס לטרנזקציית הטעינה הפעילה בלבד</h3>
      {getEmailPhoneInputElement()}
      {getLast4DigitInputElement()}
      {getSubmitButtonElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  chargePointReducer: state.chargePointReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    chargePointActions: bindActionCreators(chargePointActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargingTransactionLoginPage);
